/**
 * TODO search 和 search_sem 里重复的地方太多了，把重复的地方抽出来
 */
define('page/search', ['page/search/base', 'common/util'], (SearchBase, util) => {
    function init() {
        // 处理IE8时列表页样式
        if (util.isLegacyBrowser()) {
            $('.js-car-list > li').each(function (index, element) {
                if (index % 4 === 0) {
                    $(element).css('margin-left', '0');
                }
            });
        }
        SearchBase.init();
    }

    return {
        init,
    };
});

/* istanbul ignore if */
if (typeof window.__karma__ === 'undefined') {
    require(['page/search'], (page) => {
        page.init();
    });
}
